import React from 'react'
import { Link } from 'react-router'
import img1 from '../assets/img/illustrations/illustrations-01.png'
import img2 from '../assets/img/illustrations/illustrations-02.png'
import img3 from '../assets/img/illustrations/illustrations-03.png'
import img4 from '../assets/img/illustrations/illustrations-04.png'

class Home extends React.Component { // eslint-disable-line react/prefer-stateless-function
  render() {
    return (
      <div>
        <section className="section--tight pt-1">
          <div className="container">
            <div className="row d-block">
              <h3 className="text-center" style={{ color: '#2D88C7' }}>Saiba como participar e indicar parceiros</h3>
              <hr />
              <div className="row mt-1 mb-1 mt-lg-5 mb-lg-5">
                <div className="col-12 col-lg-8">
                  <div className="list-inline text-md-left mt-5 pt-lg-3">
                    <h1 className="list-inline-item display-1">1.</h1>
                    <div className="list-inline-item pl-4  text-left">
                      <h3 style={{ color: '#2D88C7' }}>Acesse o Gravíttem</h3>
                      <span className="pt-1" style={{ color: '#979797', lineHeight: '1.5rem', fontSize: '1.2rem' }}>
                        Dentro do sistema Gravíttem procure a <span style={{ color: '#757575', fontSize: '1.2rem', fontWeight: 'bold' }}>área de <br />indicação</span> para iniciar o processo.
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-4 text-center">
                  <img className="w-75 img-fluid" src={img1} alt="gravittem" />
                </div>
              </div>
              <div className="row mt-1 mb-1 mt-lg-5 mb-lg-5 flex-lg-row-reverse">
                <div className="col-12 col-lg-8">
                  <div className="list-inline text-md-right mt-5 pt-lg-3">
                    <h1 className="list-inline-item display-1">2.</h1>
                    <div className="list-inline-item pl-4  text-left">
                      <h3 style={{ color: '#2D88C7' }}>Envie o link de indicação</h3>
                      <span className="pt-1" style={{ color: '#979797', lineHeight: '1.5rem', fontSize: '1.2rem' }}>
                        <span style={{ color: '#757575', fontSize: '1.2rem', fontWeight: 'bold' }}>Copie o link </span>de indicação que estiver disponível e<br /><span style={{ color: '#757575', fontSize: '1.2rem', fontWeight: 'bold' }}>envie </span>para seus parceiros.
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-4 text-center">
                  <img className="w-75 img-fluid" src={img2} alt="gravittem" />
                </div>
              </div>
              <div className="row mt-1 mb-1 mt-lg-5 mb-lg-5">
                <div className="col-12 col-lg-8">
                  <div className="list-inline text-left mt-5 pt-lg-3">
                    <h1 className="list-inline-item display-1">3.</h1>
                    <div className="list-inline-item pl-4 text-left">
                      <h3 style={{ color: '#2D88C7' }}>Aguarde sua indicação</h3>
                      <span className="pt-1" style={{ color: '#979797', lineHeight: '1.5rem', fontSize: '1.2rem' }}>Aguarde até que sua indicação <span style={{ color: '#757575', fontSize: '1.2rem', fontWeight: 'bold' }}>se torne um cliente<br /></span> Gravíttem para ganhar o desconto.</span>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-4 text-center">
                  <img className="w-75 img-fluid" src={img3} alt="gravittem" />
                </div>
              </div>
              <div className="row mt-1 mb-1 mt-lg-5 mb-lg-5 flex-lg-row-reverse">
                <div className="col-12 col-lg-8">
                  <div className="list-inline text-md-right mt-5 pt-lg-3">
                    <h1 className="list-inline-item display-1">4.</h1>
                    <div className="list-inline-item pl-4 text-left">
                      <h3 style={{ color: '#2D88C7' }}>Indique quantos quiser</h3>
                      <span className="pt-1" style={{ color: '#979797', lineHeight: '1.5rem', fontSize: '1.2rem' }}>Quanto mais <span style={{ color: '#757575', fontSize: '1.2rem', fontWeight: 'bold' }}>indicações </span>adquirirem o Gravíttem,<br />mais <span style={{ color: '#757575', fontSize: '1.2rem', fontWeight: 'bold' }}>descontos </span>você receberá. <Link style={{ fontSize: '1.2rem', lineHeight: '1.5rem' }} to="/Regulation">Acesse o<br /> regulamento</Link> para saber mais.</span>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-4 text-center">
                  <img className="w-75 img-fluid" src={img4} alt="gravittem" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./client/components/Home.js